import React, { PropsWithChildren } from 'react'
import { useTiaUI } from '../'
import { getCSS } from '../util'
import ReactModal, { Styles, Props } from 'react-modal'

ReactModal.defaultStyles = {}

export type ModalSize = 'xs' | 'legacyXs' | 'sm' | 'md' | 'lg' | 'xl'

export type ModalStyleOverrides = (e: Styles) => Styles

export type ModalProps = PropsWithChildren<
    Props & {
        styleOverrides?: ModalStyleOverrides
        maxWidth?: ModalSize
        preventClose?: boolean
    }
>

// TODO: maybe we should move this to themes.js & do interface merging between a new custom interface & tia-ui.Theme
// sizes taken from material-ui dialogs
const sizes = {
    // support for legacy default on modals
    legacyXs: 480,
    xs: 444,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
}

export const Modal = (props: ModalProps) => {
    const { theme } = useTiaUI()
    // for backwards compatibility, the default of isOpen is true
    const {
        shouldCloseOnOverlayClick = true,
        isOpen = true,
        styleOverrides = (e: Styles) => e,
        maxWidth = 'legacyXs',
        preventClose = false,
        onRequestClose,
        ...modalProps
    } = props

    const closeRequest = (ev: React.MouseEvent | React.KeyboardEvent) => {
        if (!preventClose && onRequestClose) {
            onRequestClose(ev)
        }
    }

    const modalStyle = styleOverrides({
        overlay: {
            backgroundColor: getCSS(theme)('color', 'modalOverlay'),
            position: 'fixed',
            zIndex: 1001,
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        } as React.CSSProperties,
        content: {
            background: 'none',
            border: 0,
            padding: 0,
            maxWidth: sizes[maxWidth] || 480,
            width: '100%',
            maxHeight: 'calc(100vh - 2rem)',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            position: 'relative',
            overflowY: 'auto',
            outline: 'none'
        } as React.CSSProperties
    })

    return (
        <ReactModal
            isOpen={isOpen}
            style={modalStyle}
            parentSelector={() => document.body}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            onRequestClose={closeRequest}
            {...modalProps}
        />
    )
}
